import React, { useContext } from 'react'
import styled from 'styled-components'
import Flex from '@jarvis.oddle/core/components/Flex'
import Div from '@jarvis.oddle/core/components/Div'
import Dropdown from '@jarvis.oddle/core/components/Dropdown'
import IconArrow, {
  arrowDirections
} from '@jarvis.oddle/core/components/Icons/IconArrow'
import { Text } from '@jarvis.oddle/core/components/Typo'
import {
  borderRadius,
  borderRadiusSizes,
  colors,
  marginSizes
} from '@jarvis.oddle/core/theme/default'
import IconShoppingBag from '@jarvis.oddle/core/components/Icons/IconShoppingBag'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'

const DropdownContainer = styled(Div)`
  top: 100%;
  width: 100%;
  background-color: ${colors.colorContainerColor};
  border-radius: ${borderRadius[borderRadiusSizes.small]};
  max-height: 60vh;
  overflow: auto;
  ${(props) => (props.show ? '' : 'display: none;')}
`

const StyledDropdownLabel = styled(Flex).attrs(() => ({
  role: 'button',
  justifyContent: 'space-between',
  alignItems: 'center'
}))`
  cursor: pointer;
`

const StyledAmountContainer = styled(Flex).attrs(() => ({
  flexDirection: 'row',
  alignItems: 'center'
}))``

const StyledTextAndIcon = styled(Flex)`
  align-items: center;
`

const StyledTextHeading = styled(Text)`
  color: ${(props) => props.theme.colorHeadingsFont};
`

const OrderSummaryDropdown = ({
  OrderSummary,
  orderTotal
}: {
  OrderSummary: JSX.Element
  orderTotal: string
}): JSX.Element => {
  const { t } = useContext(TranslationContext)
  return (
    <Dropdown
      renderLabel={({ toggleDropdown, isDropdownOpening }) => (
        <StyledDropdownLabel
          data-testid='orderSummaryDropdown.label'
          onClick={toggleDropdown}
        >
          <StyledTextAndIcon>
            <IconShoppingBag width={24} height={24} />
            <StyledTextHeading marginLeft={marginSizes.small} bold>
              {isDropdownOpening ? t('Hide') : t('Show')} {t('Order Summary')}
            </StyledTextHeading>
          </StyledTextAndIcon>
          <StyledAmountContainer>
            <Text marginRight={marginSizes.small}>{orderTotal}</Text>
            <IconArrow
              iconSize='small'
              direction={
                isDropdownOpening ? arrowDirections.up : arrowDirections.down
              }
            />
          </StyledAmountContainer>
        </StyledDropdownLabel>
      )}
      renderDropdown={({ isDropdownOpening }) =>
        isDropdownOpening ? OrderSummary : null
      }
      DropdownContainer={DropdownContainer}
    />
  )
}

export default OrderSummaryDropdown
